export default "/_next/static/images/Traditional-f1ca2db3a38dd7cd75de908277f75c0c.png";